module.exports = __webpack_public_path__ + "img/schedule_new.f5025e93.png";